"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildSendPreset;

var _utilities = require("./utilities");

function buildSendPreset(preset) {
  const messages = Object.keys(preset).reduce((messageArray, key) => {
    const paramKey = (0, _utilities.formatParamSendName)(key),
          currentItem = preset[key];

    if (Array.isArray(preset[key])) {
      const paramValues = currentItem.map((item, index) => (0, _utilities.reduceParamObject)(item, index)); // param objects array

      paramValues.forEach((values, index) => {
        messageArray.push({
          param: paramKey,
          values: values
        });
      });
    } else if (typeof currentItem === 'object') {
      // single param object
      messageArray.push({
        param: paramKey,
        values: (0, _utilities.reduceParamObject)(currentItem)
      });
    } else {
      // single items
      messageArray.push({
        param: paramKey,
        values: paramKey === 'gain' && currentItem === '1.00' ? '1.001' : String(currentItem)
      });
    }

    return messageArray;
  }, []);
  return messages;
}